export default __webpack_public_path__ + "6654f1a34d92d38f69b403e575f3601b.png";